module.exports = __webpack_public_path__ + "static/video/patrick_bernatchez_2.ce69d89.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/commons/video/patrick_bernatchez_2.mp4
// module id = PN7l
// module chunks = 0